import React, { useState, useEffect, useMemo } from "react";
import toastr from "toastr";
import { convertHexToString } from "./web3Intraction";
import * as WalletConnect from "./walletconnect";
import * as metaConnect from "./metamaskTransactions";
import { ethers } from "ethers";

export const MetaMaskContext = React.createContext(null);

export const MetaMaskProvider = ({ children }) => {
  const [walletType, setwalletType] = useState("metamask");
  const [isActive, setIsActive] = useState(false);
  const [account, setaccount] = useState("");
  const [chainId, setchainId] = useState();

  useEffect(() => {
    switch (walletType) {
      case "metamask":
        if (window.ethereum) {
          addWalletListener();
          addNetworkListener();
        } else {
          setIsActive(false);
        }
        break;

      // case "walletconnect":
      //   addSessionListener();
      //   break;

      default:
        setIsActive(false);
        break;
    }
  }, [walletType]);

  const connect = async (_walletType) => {
    setwalletType(_walletType);

   // console.log("78877878",_walletType);

    localStorage.setItem("wallet_type", _walletType);
    switch (_walletType) {
      case "metamask":
        const walletResponse = await metaConnect.connectWallet();
       // console.log("obj12",walletResponse)
        if(walletResponse?.address ==""){
          setaccount("");
          setIsActive(false);
          break;
        }
        let obj = walletResponse;
      
      //  if(obj)
        setaccount(walletResponse?.address);
        localStorage.setItem("walletAddress", walletResponse?.address);
        setIsActive(true);
        return obj;
       break;

      // case "walletconnect":
      //   const _connectResponse = await WalletConnect.connectWallet();
      //   setaccount(_connectResponse.address);
      //   setIsActive(true);
      //   setchainId(_connectResponse.chainId);
      //   break;

      default:
        setaccount("");
        setIsActive(false);
        break;
    }
  };

  // Disconnect from Metamask wallet
  const disconnect = async () => {
    setaccount("");
    setIsActive(false);
  };

  function addWalletListener() {
    window.ethereum.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        setIsActive(true);
        localStorage.setItem("walletAddress", accounts.address);
        setaccount(accounts[0]);
      } else {
        setIsActive(false);
        setaccount("");
      }
    });
  }

  async function addNetworkListener() {
    setchainId(
      convertHexToString(
        await window.ethereum.request({
          method: "eth_chainId",
          params: [],
        })
      )
    );
    window.ethereum.on("chainChanged", (res) => {
      setchainId(convertHexToString(res));
    });
  }

  const values = useMemo(
    () => ({
      isActive,
      account,
      connect,
      disconnect,

      chainId,
      walletType,
    }),
    [isActive, account, chainId, walletType]
  );
  function addSessionListener() {
    setchainId(WalletConnect.getCurrentChain());
    WalletConnect.onSessionUpdate(({ accounts, chainId }) => {
      if (accounts.length > 0) {
        setIsActive(true);
        setaccount(accounts[0]);
      } else {
        setIsActive(false);
        setaccount("");
      }
      setchainId(chainId);
    });
  }

  return (
    <MetaMaskContext.Provider value={values}>
      {children}
    </MetaMaskContext.Provider>
  );
};

export const connectWallet = async (walletType) => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const obj = { address: addressArray[0] };
      return obj;
    } catch (err) {
      return { address: "" };
    }
  } else {
    window.open("https://metamask.io/download.html", "_blank");
    toastr.error(
      "You must install Metamask, a virtual Ethereum wallet, in your browser."
    );

    return { address: "" };
  }
};

export const getCurrentWalletConnected = async () => {
  try {
    const addressArray = await window.ethereum.request({
      method: "eth_accounts",
    });

    if (addressArray.length > 0) {
      return { address: addressArray[0] };
    }

    return { address: "" };
  } catch (err) {
    return { address: "" };
  }
};

export const switchChain = (params) => {
  if (window.ethereum) {
    return window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [params],
    });
  }
};

export const addChain = (params) => {
  if (window.ethereum) {
    return window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [params],
    });
  }
};

export const getContractAddress = (params) => {
  if (window.ethereum) {
    return window.ethereum.request({
      method: "eth_requestAccounts",
      // params: [params],
    });
  }
};

export const getBalance = (address) => {
  if (window.ethereum) {
    return window.ethereum
      .request({
        method: "eth_getBalance",
        params: [address],
      })
      .then((balance) => {
        return ethers.utils.formatEther(balance, "balanceOff");
      });
  }
};
